import moment from "moment-timezone";
import { atom, selector } from "recoil";

export type ThemeType = {
  theme_name: string;
  logo: string;
  area_name: string | null;
  turn_off: string | null;
  order_status: string | null;
  category: string | null;
  store_list: string | null;
  around_store: string | null;
  background: string | null;
  slide_coupons: string[];
};

/* 
=========== 매뉴얼 ============

1. theme_name은 의미없으니 마음대로 지정 (구분용)

2. background, slide_coupons에는 지정할 테마의 이름을 규정 => 아래 경로의 함수에 컴포넌트 return 값 추가 필요
  - background 테마 지정은 MainPage.tsx의 getBackground()
  - slide_coupons 테마 지정은 EventSlider.tsx의 getSlide()

3. 나머지 변수는 해당 위치 옆의 아이콘 url => 아이콘 추가하고 싶지 않을경우 null

4. 외의 필요한 위치에 테마소스 넣고싶으면 type에 원하는 값 추가 (스타일 추가도 직접 해야해요 ^^)

*/

export const getDateTheme = () => {
  const currentDate = moment(new Date(), "MM-DD");
  // const currentDate = moment("03-01", "MM-DD");

  if (
    currentDate.isBetween(
      moment("12-01", "MM-DD"),
      moment("12-31", "MM-DD"),
      null,
      "[]"
    )
  ) {
    return {
      theme_name: "christmas",
      logo: `${process.env.PUBLIC_URL}/knockknock/img/christmas/knock_logo.gif`,
      area_name: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_santa.svg`,
      turn_off: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_tree.svg`,
      order_status: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_bell.svg`,
      category: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_box.svg`,
      store_list: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_sock.svg`,
      around_store: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_snowman.svg`,
      background: "snow",
      slide_coupons: ["check_in", "christmas"],
    };
  } else if (
    currentDate.isBetween(
      moment("01-01", "MM-DD"),
      moment("02-28", "MM-DD"),
      null,
      "[]"
    )
  ) {
    return {
      theme_name: "winter",
      logo: `${process.env.PUBLIC_URL}/knockknock/img/christmas/knock_logo.gif`,
      area_name: null,
      turn_off:  `${process.env.PUBLIC_URL}/knockknock/svg/ic_off.svg`,
      order_status:  `${process.env.PUBLIC_URL}/knockknock/svg/ic_history.svg`,
      category: null,
      store_list: null,
      around_store: null,
      background: "snow",
      slide_coupons: ["check_in","christmas"],
    };
  }
  // else if (
  //   currentDate.isBetween(
  //     moment("03-01", "MM-DD"),
  //     moment("05-31", "MM-DD"),
  //     null,
  //     "[]"
  //   )
  // ) {
  //   return {
  //     theme_name: "spring",
  //     logo: `${process.env.PUBLIC_URL}/knockknock/img/knockMainLogo.png`,
  //     area_name: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_santa.svg`,
  //     turn_off: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_tree.svg`,
  //     order_status: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_bell.svg`,
  //     category: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_box.svg`,
  //     store_list: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_sock.svg`,
  //     around_store: `${process.env.PUBLIC_URL}/knockknock/svg/event/ic_snowman.svg`,
  //     background: "spring",
  //     slide_coupons: ["check_in"],
  //   };
  // }
  else {
    return {
      theme_name: "standard",
      logo: `${process.env.PUBLIC_URL}/knockknock/img/knockMainLogo.png`,
      area_name: null,
      turn_off: null,
      order_status: null,
      category: null,
      store_list: null,
      around_store: null,
      background: "none",
      slide_coupons: ["check_in"],
    };
  }
};

export const ThemeState = atom<ThemeType>({
  key: "theme",
  default: getDateTheme(),
});
